import type { Location } from "react-router";

export type InternFooterEntity = {
  typename: "LlmConversation" | "JobRun";
  globalId: string;
};

// URL matchers for routes with an InternFooter-resolvable entity.
//
// Chat conversations:
//   - /chat/c/:id is the canonical route (see ChatsPage.tsx navigation).
//   - /chats/c/:id is a legacy backcompat redirect path (see routes-config.tsx
//     ChatsConversationRedirect). We match both so the footer doesn't flash off
//     during the brief redirect window.
// JobRuns:
//   - /digests/run/:id (digest job run details)
//   - /investigations/:id (dagvestigation details — same JobRun type)
const CHAT_RE = /^\/chats?\/c\/([^/]+)/;
const DIGEST_RUN_RE = /^\/digests\/run\/([^/]+)/;
const INVESTIGATION_RE = /^\/investigations\/([^/]+)/;

export function resolveInternFooterEntity(location: Location): InternFooterEntity | null {
  const chat = location.pathname.match(CHAT_RE);
  if (chat) return { typename: "LlmConversation", globalId: chat[1] };
  const digest = location.pathname.match(DIGEST_RUN_RE);
  if (digest) return { typename: "JobRun", globalId: digest[1] };
  const investigation = location.pathname.match(INVESTIGATION_RE);
  if (investigation) return { typename: "JobRun", globalId: investigation[1] };
  return null;
}
